import { plainToClass } from "class-transformer";
import { AppUserExtended, JsonItem, PickListItem, IControllerFilter, PickListItemSorted, RevamppCore, RevamppProject, PickListItemString, Manuscript } from "../../../secure/list-management/scripts/list-management.objects";
import { FilterTab, Filter, DropdownGroup } from "../../../secure/list-management/scripts/list-management.filters";
import { ManuscriptsEditControllerConfig, ManuscriptsTableConfig, ManuscriptsGroupFilterItem } from "./edit-manuscripts.objects";
import { getDisplayDate } from '../../../shared/scripts/date-functions';
import { TableColumnGroup, TableColumnVisibilityControllerV2 } from "../../../shared/scripts/table-column-visibility";
import { EditManuscriptsController, AddManuscriptsController } from "./edit-manuscripts.controllers";
import _ from "lodash";
import {
    InitializeFilterDropdown,
    InitializeFilterOptGroupDropdown,
    DropdownOptGroup
} from "../../../shared/scripts/dropdown-functions";
export class ManuscriptsTable implements IControllerFilter {
    // Config Variables
    tableContainerId: string;
    getManuscriptsRoute: string;
    loadingContainerId: string;
    loadedContentId: string;
    isAdmin: boolean;
    isEditable: boolean;
    tableVarName: string;
    additionalInfoModalId: string;

    // Table Variables
    id: string;
    referenceId: string;
    manuscripts: Manuscript[] = [];
    pickLists: JsonItem[] = [];
    sortedPickLists: JsonItem[] = [];
    allPickLists: JsonItem[] = [];
    manuscriptTable: any;
    tableColumnGroups: TableColumnGroup[];
    tableController: TableColumnVisibilityControllerV2;
    currentTargetItem: any;
    visibleManuscripts: Manuscript[] = [];

    // Edit Controllers
    editController: EditManuscriptsController;

    // Add Controllers
    addController: AddManuscriptsController;

 
    filterTabs: FilterTab[];
    columns: any[];
    EmptyDisplay = '-none-';

    // Edit manuscripts permissions
    getEditableManuscriptIdsRoute: string;

    //What is editable source
    private editableIdSet = new Set<number>();

    // Editable rows filter boolan flag for memory
    private showEditableOnly: boolean = false;

    //Permissions for add new manuscript
    private canAddNewManuscripts: boolean = false;

    constructor(config: ManuscriptsTableConfig) {
        this.tableContainerId = config.tableContainerId;
        this.getManuscriptsRoute = config.getManuscriptsRoute;
        this.loadingContainerId = config.loadingContainerId;
        this.loadedContentId = config.loadedContentId;
        this.isEditable = config.isEditable;
        this.isAdmin = config.isAdmin;
        this.tableVarName = config.tableVarName;
        this.additionalInfoModalId = config.additionalInfoModalId;
        this.referenceId = `ms-${this.makeSafeId(this.tableContainerId)}`;
        this.id = `revampp-manuscripts-${this.referenceId}`;
        this.getEditableManuscriptIdsRoute = config.getEditableManuscriptIdsRoute; //Added to config


       //Filter Tabs
        this.filterTabs = [
           
            new FilterTab("overview", "Overview", "Overview", [
                new Filter(`${this.referenceId}-status-filter`, "Status", "ms-status", "StatusId", "pl-ms-status"),
                new Filter(`${this.referenceId}-center-filter`, "Center", "multi-select-pl-single", "CenterId", "pl-center"),
                new Filter(`${this.referenceId}-core-project-filter`, "Core/Project", "ms-core-project-filter", "CenterId", "pl-center", ["CoreIds", "ProjectIds"], ["pl-core", "pl-project"]),
                new Filter(`${this.referenceId}-collab-centers-filter`, "Collaborating Centers", "multi-select-pl-multi", "CollaboratingCenterIds", "pl-center"),

            ]),

            // 2) Authors
            new FilterTab("authors", "Authors", "Authors", [
                new Filter(`${this.referenceId}-primary-author-filter`, "Primary Author", "search-multi-select-pl-single", "PrimaryAuthorId", "pl-user"),
                new Filter(`${this.referenceId}-senior-author-filter`, "Senior Author", "search-multi-select-pl-single", "SeniorAuthorId", "pl-user"),
                new Filter(`${this.referenceId}-network-authors-filter`, "Network Authors", "search-multi-select-pl-multi", "NetworkAuthorIds", "pl-user"),

            ]),

            // 3) Publications
            new FilterTab("publications", "Publication / Journal", "Publication / Journal", [
                new Filter(`${this.referenceId}-target-journal-filter`, "Target Journal", "search-multi-select", "TargetJournal"),

            ]),
        ];


        this.columns = [
            {
                data: 'Title',
                title: 'Title',
                className: 'b-fixed-left font-size12 text-left table-column-lg',
                render: (d: string, type: string, row: Manuscript) =>
                    type !== 'display'
                        ? (d || '')
                        : `<a href="#" class="ms-title-link font-weight-500"
                         data-msid="${row.Id}">${_.escape(d || '')}</a>`

            },

            {
                data: "StatusId",
                title: "Status",
                className: "overview text-left font-size12 nowrap",
                render: d => this.renderPickListItem(d, "pl-ms-status", false, true)

            },
            {
                data: "CenterId",
                title: "Center",
                className: "overview text-left font-size12 nowrap",
                render: d => this.renderPickListItem(d, "pl-center")
            },
            {
                data: null,
                title: "Core/Project",
                className: "overview text-left font-size12 table-column-lg lh-normal nowrap",
                render: row => this.renderCoreProject(row)
            },
            {
                data: "CollaboratingCenterIds",
                title: "Collaborating Centers",
                className: "overview text-left font-size12 table-column-md",
                render: d => this.renderPickListItem(d, "pl-center", true)
            },
            {
                data: "LastUpdated",
                title: "Last Updated",
                className: "overview text-left font-size12 nowrap",
                render: d => getDisplayDate(d)
            },

            { data: "Notes", title: "Notes", className: "invisible text-left font-size12",
            visible: false },

            // ---- Authors
            {
                data: "PrimaryAuthorId",
                title: "Primary Author",
                className: "authors text-left font-size12 nowrap",
                render: d => this.renderPickListItem(d, "pl-user")
            },
            {
                data: "SeniorAuthorId",
                title: "Senior Author",
                className: "authors text-left font-size12 nowrap",
                render: d => this.renderPickListItem(d, "pl-user")
            },
            {
                data: "NetworkAuthorIds",
                title: "Network Authors",
                className: "authors text-left font-size12 table-column-md",
                render: d => this.renderPickListItem(d, "pl-user", true)
            },

            // ---- Publications = target journal, pubmedif, doi, pmcid
            { data: "TargetJournal", title: "Target Journal", className: "pubids text-left font-size12 table-column-md" },

            { data: "AnticipatedDate", title: "Anticipated Date", className: "pubids text-left font-size12 table-column-md", render: d => getDisplayDate(d) },

            { data: "PubMedId", title: "PMID", className: "pubids text-left font-size12 nowrap table-column-sm" },
 
            { data: "Pmcid", title: "PMCID", className: "pubids text-left font-size12 nowrap table-column-sm" },
            { data: "Doi", title: "DOI", className: "pubids text-left font-size12 nowrap table-column-md" }
        

        
        ];

        // 
        this.tableColumnGroups = [
            new TableColumnGroup("Overview", true, [], "overview"),
            new TableColumnGroup("Authors", false, [], "authors"),
            new TableColumnGroup("Publication / Journal", false, [], "pubids")
        ];


        if (this.isEditable) {
            let editConfig: ManuscriptsEditControllerConfig = {
                isAdmin: config.isAdmin,
                modalIdTarget: config.editModalId,
                submitRoute: config.postRoute,
                tableVarName: config.tableVarName
            }

            this.editController = new EditManuscriptsController(editConfig, this);

            let addConfig: ManuscriptsEditControllerConfig = {
                isAdmin: config.isAdmin,
                modalIdTarget: config.addModalId,
                submitRoute: config.postRoute,
                tableVarName: config.tableVarName
            }
            this.addController = new AddManuscriptsController(addConfig, this);
        }

        this.initialize();
    }

    private makeSafeId(s: string): string {
        return String(s || "")
            .trim()
            .replace(/[^A-Za-z0-9\-_]/g, "-");
    }


    async initialize() {
        this.loadingDisplay(true);

        let result: any[] = await this.getManuscripts();
        await this.loadEditableIds();

        if (result["items"]) {
            this.manuscripts = plainToClass(Manuscript, <Manuscript[]>result["items"]);
        }
        if (result["pickLists"]) {
            this.pickLists = plainToClass(JsonItem, <JsonItem[]>result["pickLists"]);
        }
        if (result["sortedPickLists"]) {
            this.sortedPickLists = plainToClass(JsonItem, <JsonItem[]>result["sortedPickLists"]);
        }

        this.allPickLists = [...this.pickLists, ...this.sortedPickLists];

        this.createHtmlTemplate();
        this.initializeFilterAndTable();

        //Toggle view editable + not editable
        this.wireEditableOnlyToggle();

        this.loadingDisplay(false);
        this.resizeTable();
    }
    //Fetch Serve side editable Ids
    private async loadEditableIds(): Promise<void> {
        try {
            const result = await $.ajax(this.getEditableManuscriptIdsRoute, {
                method: "GET",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                cache: false
            });

            const ids = (result?.editableManuscriptIds ?? []) as any[];
            this.editableIdSet = new Set(ids.map(x => Number(x)).filter(n => !Number.isNaN(n)));

            // Permission for Add button (same permission source as editable ids)
            this.canAddNewManuscripts = !!result?.canAddNewManuscripts;
        }
        catch (e) {
            this.editableIdSet = new Set<number>();
            this.canAddNewManuscripts = false;
            console.log(e);
        }
    }



    async getManuscripts() {
        let result: any;
        try {
            result = await $.ajax(this.getManuscriptsRoute, {
                method: "GET",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                cache: false
            });
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    loadingDisplay(isLoading: boolean): void {
        if (isLoading) {
            $(`#${this.loadedContentId}`).addClass("d-none");
            $(`#${this.loadingContainerId}`).removeClass("d-none");
        }
        else {
            $(`#${this.loadedContentId}`).removeClass("d-none");
            $(`#${this.loadingContainerId}`).addClass("d-none");
        }
    }

    createHtmlTemplate(): void {
        let title = "";

        if (this.isEditable) {
            const showAddBtn = this.canAddNewManuscripts; // already true for Admin on server

            title = `
      <div class="d-flex align-items-center mb-4">
        <div class="content-title mr-4">In Development Manuscripts</div>

        ${showAddBtn ? `
          <div id="add-new-container">
            <button class="btn btn-small revampp-blue-btn"
                    onclick="page.${this.tableVarName}.openAddModal()">
              + Add New Manuscript
            </button>
          </div>
        ` : ""}

        <div class="ml-auto">
          ${showAddBtn ? `
            <div class="custom-control custom-switch edit-toggle">
              <input type="checkbox"
               class="custom-control-input"
               id="${this.referenceId}-editable-only-toggle"
               ${this.showEditableOnly ? 'checked' : ''}>

              <label class="custom-control-label font-size14 font-weight-500"
                     for="${this.referenceId}-editable-only-toggle">
                Editable only
              </label>
            </div>
          ` : ""}
        </div>
      </div>
    `;
        }

        // Create Content Blocks
        let content = `
    ${title}
    <div id="${this.referenceId}-filter-tab-container" class="d-flex justify-content-between">
      <ul class="nav nav-tabs justify-content-start border-bottom-0" id="${this.referenceId}-filter-tabs" role="tablist"></ul>
      <div class="d-flex align-items-center">
        <div class="font-italic pr-3" id="${this.referenceId}-table-count-found">0 Manuscripts Found</div>
        <div>
          <button class="btn btn-sm btn-outline-secondary font-size12" onclick="page.${this.tableVarName}.resetFilters()">Reset Filters</button>
        </div>
      </div>
    </div>

    <div class="tab-content edit-table-filter-tab-container" id="${this.referenceId}-filter-container"></div>

    <div class="list-table-container mt-4">
      <div class="revampp-datatable border-bottom edit-table-container" id="${this.referenceId}-table-container"></div>
    </div>
    <div id="${this.referenceId}-detail-menu-container"></div>
  `;

        $(`#${this.tableContainerId}`).empty().html(content);
    }


    initializeFilterAndTable() {
        // Filter Tabs
        this.generateFilterTabContent();

        // Select Table
        $(`#${this.referenceId}-table-container`).empty().html(
            `<table id="${this.referenceId}-select-table" class="table table-striped selectable-rows w-100" style="width:100%"></table>`
        )

        // Clear Detail Menu Container
        $(`#${this.referenceId}-detail-menu-container`).empty();

        // Create Table
        this.initializeTable();

        // Initialize Modal
        this.initializeAdditionalInfoModal();

        this.triggerFilter();
    }

    //Wire Toggle
    private wireEditableOnlyToggle(): void {
        const sel = `#${this.referenceId}-editable-only-toggle`;

        $(`#${this.tableContainerId}`)
            .off('change', sel) // Prevent duplicate binding
            .on('change', sel, (e) => { // Listen for toggle change
                this.showEditableOnly = (e.target as HTMLInputElement).checked;
                this.triggerFilter();
            });
    }

generateFilterTabContent(): void {
    // Create new Tab Content
    let tabContent = "";
    let filtersContent = "";

    for (let i = 0; i < this.filterTabs.length; i++) {
        const currentFilter = this.filterTabs[i];
        const filterNumber = currentFilter.filters.length;

        // Namespace tab + pane ids 
        const tabId = `${this.referenceId}-${currentFilter.id}-tab`;
        const paneId = `${this.referenceId}-${currentFilter.id}`;

        if (i === 0) {
            tabContent += `
                <li class="nav-item">
                    <a class="nav-link active"
                       id="${tabId}"
                       data-toggle="tab"
                       href="#${paneId}"
                       role="tab"
                       aria-controls="${paneId}"
                       aria-selected="true">
                        ${currentFilter.displayName}
                    </a>
                </li>`;

            filtersContent += `
                <div class="tab-pane fade show active"
                     id="${paneId}"
                     role="tabpanel"
                     aria-labelledby="${tabId}">
                    <div class="row">`;
        } else {
            tabContent += `
                <li class="nav-item">
                    <a class="nav-link"
                       id="${tabId}"
                       data-toggle="tab"
                       href="#${paneId}"
                       role="tab"
                       aria-controls="${paneId}"
                       aria-selected="false">
                        ${currentFilter.displayName}
                    </a>
                </li>`;

            filtersContent += `
                <div class="tab-pane fade"
                     id="${paneId}"
                     role="tabpanel"
                     aria-labelledby="${tabId}">
                    <div class="row">`;
        }

        for (let j = 0; j < currentFilter.filters.length; j++) {
            const filter = currentFilter.filters[j];
            filtersContent += this.generateFilterHtml(filter, filterNumber);
        }

        filtersContent += `</div></div>`;
    }

    // Update Tabs
    $(`#${this.referenceId}-filter-tabs`).empty().html(tabContent);
    $(`#${this.referenceId}-filter-container`).empty().html(filtersContent);

    // Generate Dropdowns
    for (let i = 0; i < this.filterTabs.length; i++) {
        const currentFilterTab = this.filterTabs[i];
        for (let j = 0; j < currentFilterTab.filters.length; j++) {
            const currentFilter = currentFilterTab.filters[j];
            this.initializeFilterDropdown(currentFilter);
        }
    }

    // Hook tab click 
    this.filterTabs.forEach(tab => {
        if (tab.columnViewName) {
            $(`#${this.referenceId}-${tab.id}-tab`).off("click").on("click", () => {
                $(`#column-filter-dropdown-${this.id}-table-column-visibility`).val([`${tab.columnViewName}`]);
                $(`#column-filter-dropdown-${this.id}-table-column-visibility`).trigger("change");
            });
        }
    });

    $(`#${this.referenceId}-filter-container`)
        .find('select')
        .off('changed.bs.select')
        .on('changed.bs.select', () => this.triggerFilter());

}

    generateFilterHtml(filter: Filter, numberFilters: number): string {
        let content = "";

       
        if (filter.type === "ms-status") {
            content = `
            <div id="${filter.id}-select" class="col-12 col-md-3 mb-2">
                <div id="${filter.id}-block" class="filter-label d-inline-block label-only">
                    ${filter.displayName}
                </div>
                <select id="${filter.id}-dropdown"
                        class="selectpicker dropdown"
                        title="None Selected"
                        data-actions-box="true"
                        data-width="100%"
                        data-container="body"
                        data-size="10"
                        multiple>
                </select>
            </div>
        `;
        }
        else if (filter.type === "ms-core-project-filter") {
            content = `
            <div id="${filter.id}-select" class="col-12 col-md-3 mb-2">
                <div id="${filter.id}-block" class="filter-label d-inline-block label-only">${filter.displayName}</div>
                <select id="${filter.id}-dropdown" class="selectpicker dropdown" title="None Selected" data-actions-box="true" data-width="100%" data-container="body" data-size="10" multiple>
                </select>
            </div>
        `;
        }
        else {
            content = filter.generateFilterHtml();
        }

        if (numberFilters > 4) {
            content = content.replace("col-md-3", "col-md-3 col-lg-2");
        }

        return content;
    }


    initializeFilterDropdown(filter: Filter): void {

        // 0) Status filter (sorted by SortOrder)
        if (filter.type === "ms-status") {

            const statusPickList: PickListItemSorted[] =
                this.sortedPickLists.find(list => list.Id === "pl-ms-status")?.Json ?? [];

            const options: string[][] = [];

            statusPickList
                .sort((a, b) => a.SortOrder - b.SortOrder)
                .forEach(item => {
                    options.push([item.Id.toString(), item.Value]);
                });

            InitializeFilterDropdown(
                `#${filter.id}-dropdown`,
                null,
                this,
                options,
                true,
                false
            );

            const $dd = $(`#${filter.id}-dropdown`);

            // Select everything first
            $dd.find('option').prop('selected', true);

            // Explicitly deselect SortOrder 4 : Published and 5 : Discontinued
            const excludeIds = statusPickList
                .filter(s => s.SortOrder === 4 || s.SortOrder === 5)
                .map(s => s.Id.toString());

            excludeIds.forEach(id => {
                $dd.find(`option[value="${id}"]`).prop('selected', false);
            });

            try { ($dd as any).selectpicker('refresh'); } catch { }

            return;
        }

        // 1) Core/Project optgroup filter
        if (filter.type == "ms-core-project-filter") {
            // Base picklists
            const centerPickList: PickListItem[] =
                this.pickLists.find(list => list.Id == "pl-center")?.Json ?? [];
            const allCores: RevamppCore[] =
                this.pickLists.find(list => list.Id == "pl-all-cores")?.Json ?? [];
            const allProjects: RevamppProject[] =
                this.pickLists.find(list => list.Id == "pl-all-projects")?.Json ?? [];

            const optGroups: DropdownOptGroup[] = [];

            // Sort centers alphabetically
            centerPickList.sort((a, b) => a.Value.localeCompare(b.Value));

            centerPickList.forEach(center => {
                const options: string[][] = [];

                // Cores for this center
                const coresForCenter = allCores.filter(c => c.CenterId === center.Id);
                coresForCenter.forEach(c => {
                    options.push([
                        `${center.Id}|core-${c.Id}`,
                        c.CoreName
                    ]);
                });

                // Projects for this center
                const projectsForCenter = allProjects.filter(p => p.CenterId === center.Id);
                projectsForCenter.forEach(p => {
                    options.push([
                        `${center.Id}|project-${p.Id}`,
                        p.ProjectName
                    ]);
                });

                // Only add centers that actually have cores or projects
                if (options.length > 0) {
                    optGroups.push(new DropdownOptGroup(center.Value, options));
                }
            });

            InitializeFilterOptGroupDropdown(
                `#${filter.id}-dropdown`,
                optGroups,
                this,
                false,
                false
            );
            return;
        }

        // 2) Non core/project filters 
        if (filter.pickListName) {
            const pl: PickListItem[] =
                this.pickLists.find(list => list.Id == filter.pickListName)?.Json ?? [];
            filter.initializeDropdown(this.manuscripts, this, pl);
        } else {
            filter.initializeDropdown(this.manuscripts, this);
        }
    }

    initializeAdditionalInfoModal(): void {
        $(`#${this.referenceId}-additional-info-btn`).off().on('click', () => {
            $(`#${this.additionalInfoModalId}`).modal('show');
        })
    }

    getSelectedFilterTabId(): string {
        let selectedTab = $(`#${this.referenceId}-filter-tabs`).find(".active").first();
        return selectedTab.prop("id");
    }

    triggerFilter(): void {
        let filteredItems: any[] = _.cloneDeep(this.manuscripts);

        const activeTabLinkId = this.getSelectedFilterTabId() || "";
        const tabKey = activeTabLinkId
            .replace(`${this.referenceId}-`, "")
            .replace("-tab", "");
        const activeTab = this.filterTabs.find(t => t.id === tabKey);

        // Apply tab filters
        if (activeTab) {
            activeTab.filters.forEach(filter => {
                if (filter.type === "ms-status") {
                    const $dd = $(`#${filter.id}-dropdown`);
                    const selected = ($dd.val() as string[] | null) ?? [];
                    const allCount = $dd.find("option").length;

                    if (selected.length === 0) {
                        filteredItems = [];
                        return;
                    }

                    if (allCount > 0 && selected.length === allCount) {
                        return;
                    }

                    filteredItems = filteredItems.filter(x =>
                        selected.includes(String(x.StatusId))
                    );
                    return;
                }

                if (filter.type === "ms-core-project-filter") {
                    filteredItems = this.filterCoreProject(filteredItems, filter);
                } else {
                    filteredItems = filter.filterItems(filteredItems);
                }
            });
        }

        // Toggle view of editable manuscripts treat as filter
        if (this.showEditableOnly) {
            filteredItems = filteredItems.filter(m =>
                this.editableIdSet.has(Number(m.Id))
            );
        }

        this.updateTable(filteredItems);
    }



    filterCoreProject(items: Manuscript[], filter: Filter): Manuscript[] {
        const selectedItems: ManuscriptsGroupFilterItem[] = [];
        const selectedOptions = $(`#${filter.id}-dropdown`).find("option:selected");
        const isNoneSelected = selectedOptions.length === 0;

        selectedOptions.each(function () {
            const raw = $(this).val() as string;
            if (!raw) return;

            const [categoryIdStr, itemId] = raw.split("|");
            const categoryId = parseInt(categoryIdStr, 10);

            if (!Number.isNaN(categoryId) && itemId) {
                selectedItems.push(new ManuscriptsGroupFilterItem(categoryId, itemId));
            }
        });

        if (isNoneSelected) {
            return items;
        }

        // Apply filter
        return items.filter(item => {
            const centerId = item.CenterId;

         
            const coreIds = item.CoreIds
                ? item.CoreIds.split("|").map(coreId => `core-${coreId}`)
                : [];
            const projectIds = item.ProjectIds
                ? item.ProjectIds.split("|").map(projectId => `project-${projectId}`)
                : [];

            // 1) Manuscript center must be selected
            const hasCenter = selectedItems.some(sel => sel.categoryId === centerId);
            if (!hasCenter) {
                return false;
            }

            // 2) Manuscript must share at least one selected core or project
            const hasCoreOrProject = selectedItems.some(sel =>
                coreIds.includes(sel.itemId) || projectIds.includes(sel.itemId)
            );
            if (!hasCoreOrProject) {
                return false;
            }

            return true;
        });
    }



    resetFilters(): void {


        this.filterTabs.forEach(tab => {
            tab.filters.forEach(filter => {
                if (filter.type == "ms-core-project-filter") {
                    $(`#${filter.id}-dropdown`).selectpicker("deselectAll");
                    return;
                }
                //Special Status reset
                if (filter.type === "ms-status") {
                    const $dd = $(`#${filter.id}-dropdown`);
                    $dd.find("option").prop("selected", true);
                    try {
                        ($dd as any).selectpicker("refresh");} 
                        catch { }
                        return;
                    }
                
              
                   filter.resetFilter();
              
                });
            });

        this.triggerFilter();
    }


    renderPickListItem(data: any, pickListName: string, isMultiple: boolean = false, isSorted: boolean = false, separator: string = ", "): string {
        if (!data) {
            return "";
        }

        let sortedPickList: PickListItemSorted[] = [];
        let pickList: PickListItem[] = [];

        if (isSorted) {
            let foundList: PickListItemSorted[] = this.sortedPickLists.find(list => list.Id == pickListName)?.Json;
            if (foundList) {
                sortedPickList = foundList;
            }
        }
        else {
            let foundList: PickListItem[] = this.pickLists.find(list => list.Id == pickListName)?.Json;
            if (foundList) {
                pickList = foundList;
            }
        }

        if (sortedPickList.length == 0 && pickList.length == 0) {
            return "";
        }

        let returnStrArray: string[] = [];
        let returnStr: string = "";
        if (isMultiple) {
            let stringArrIds: string[] = data.split("|");
            stringArrIds = _.uniq(stringArrIds);

            for (let i = 0; i < stringArrIds.length; i++) {
                let numId: number = parseInt(stringArrIds[i]);
                if (numId) {
                    let foundItem = null;
                    if (isSorted) {
                        foundItem = sortedPickList.find(item => item.Id == numId);
                    }
                    else {
                        foundItem = pickList.find(item => item.Id == numId);
                    }

                    if (foundItem) {
                        returnStrArray.push(foundItem.Value);
                    }
                }
            }

            returnStrArray.sort();
            returnStr = returnStrArray.join(separator);
        }
        else {
            let foundItem = null;
            if (isSorted) {
                foundItem = sortedPickList.find(item => item.Id == data);
            }
            else {
                foundItem = pickList.find(item => item.Id == data);
            }

            if (foundItem) {
                returnStr = foundItem.Value;
            }
        }

        return returnStr;
    }

    renderCoreProject(data: Manuscript) {
        const coreList = this.pickLists.find(l => l.Id === "pl-core")?.Json ?? [];
        const projectList = this.pickLists.find(l => l.Id === "pl-project")?.Json ?? [];

        let coreIds = data.CoreIds.split("|");
        let projectIds = data.ProjectIds.split("|");

        let coreNames: string[] = [];
        coreIds.forEach(coreId => {
            let foundCore = coreList.find(core => core.Id.toString() == coreId);
            if (foundCore) coreNames.push(foundCore.Value);
        });
        coreNames.sort();

        let projectNames: string[] = [];
        projectIds.forEach(projectId => {
            let foundProject = projectList.find(project => project.Id.toString() == projectId);
            if (foundProject) projectNames.push(foundProject.Value);
        });
        projectNames.sort();

        let content = "";
        let combinedNames: string[] = [...coreNames, ...projectNames];
        combinedNames.forEach(name => {
            if (content.length != 0) content += "<hr class='my-1'>";
            content += `${name}`;
        });
        return content;
    }


    initializeTable(): void {
        let columns = _.cloneDeep(this.columns);

        let tableColumns: any[] = [];
        let firstColumn = columns.shift();
        if (firstColumn) {
            tableColumns.push(firstColumn);
            if (this.isEditable) {
                tableColumns.push(
                    { data: "Id", title: "", width: "26px", orderable: false, className: "text-center detail-btn-container", render: (data) => this.renderDetailButton(data) }
                )
            }
        }
        tableColumns.push(...columns);

        const fixedColCount = this.isEditable ? 2 : 1;


        this.manuscriptTable = $(`#${this.referenceId}-select-table`).DataTable({
            "dom": `<"${this.id}-top-controls"<"${this.id}-column-select"><"${this.id}-search-bar"f><"${this.id}-count-found"B>>rtip`,
            autoWidth: true,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            //responsive: false,
            scrollY: '60vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: fixedColCount
            },
            language:
            {
                search: "Search",
            },
            columns: tableColumns,
            buttons: [
                {
                    extend: 'csv',
                    filename: "revampp_manuscripts",
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8'
                }
            ],
            data: this.manuscripts,
            order: [[0, 'asc']],
            initComplete: (settings, json) => {

            },
        });

        $(`.${this.id}-top-controls`).addClass('row mx-0 align-items-center');

        $(`.${this.id}-column-select`).addClass('col-12 col-md-3 px-0 mb-2');
        $(`.${this.id}-column-select`).empty().html(`<div id="${this.id}-column-select"></div>`);
        $(`.${this.id}-search-bar`).addClass('col-12 col-md-3');
        $(`.${this.id}-count-found`).addClass('col-12 col-md-6 d-flex justify-content-end vertical-align-middle mt-3 px-0');
        $(`.${this.id}-count-found`).prepend('<div id="selected-items-block" class="align-self-center pr-3"></div>');

        this.tableController = new TableColumnVisibilityControllerV2(`#${this.referenceId}-select-table`, `#${this.id}-column-select`, this.tableColumnGroups, `${this.id}-table-column-visibility`);
       

        this.updateCount(this.manuscripts.length);
        this.visibleManuscripts = this.manuscripts;
        this.wireRowActions();
    }


    updateCount(numItems: number): void {
        let content = "";
        if (numItems == 1) {
            content = "1 Manuscript Found"
        }
        else {
            content = `${numItems.toString()} Manuscripts Found`
        }

        $(`#${this.referenceId}-table-count-found`).text(content);
    }
     
    renderDetailButton(data: any): string {
        return `
    <div class="btn-group dropright">
      <button type="button"
              class="btn dropdown-toggle p-0"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              onclick="page.${this.tableVarName}.updateMenuPosition(event)">
        <div class="item-detail-button" data-id="${data}">
          <div><i class="fa-solid fa-ellipsis"></i></div>
        </div>
      </button>
      <div class="dropdown-menu revampp-dropdown-menu"></div>
    </div>
  `;
    }


    updateMenuPosition(e: Event) {
        // set current selected row
        let targetElement = <JQuery<HTMLElement>>$(e.currentTarget);
        let table = $(targetElement).closest("table");
        this.setTargetedRow(targetElement);

        $(`#${this.referenceId}-detail-menu-container`).empty();

        let dropdownMenu = targetElement.siblings('.revampp-dropdown-menu');
        let dropdownContainer = targetElement.parent();

        if (dropdownMenu.length <= 0) {
            targetElement.dropdown('dispose');
            dropdownContainer.append(`
                <div class="dropdown-menu revampp-dropdown-menu">
                    ${this.getMenuContent()}
                </div>
            `)
            targetElement.dropdown();
            
            dropdownContainer.off().on("show.bs.dropdown", (e) => {
                let updatedDropdownMenu = dropdownContainer.find('.revampp-dropdown-menu');
                $(`#${this.referenceId}-detail-menu-container`).append(<JQuery<HTMLElement>>$(updatedDropdownMenu))
            });
        }
        else {
            dropdownMenu.html(`
                ${this.getMenuContent()}
            `)
            dropdownContainer.off().on("show.bs.dropdown", (e) => {
                let updatedDropdownMenu = dropdownContainer.find(".revampp-dropdown-menu");
                $(`#${this.referenceId}-detail-menu-container`).append(<JQuery<HTMLElement>>$(updatedDropdownMenu));
            });
        }
    }

    setTargetedRow(target: JQuery<HTMLElement>): void {
        let tr = $(target).closest('tr');
        let row = this.manuscriptTable.row(tr);
        this.currentTargetItem = <Manuscript>row.data();
    }

    getMenuContent(): string {
        const msId = Number(this.currentTargetItem?.Id ?? 0);
        const canEdit = this.editableIdSet.has(msId);

        // not editable => view only
        if (!canEdit) {
            return `<a class="dropdown-item" onclick="page.${this.tableVarName}.openViewModal(${msId})">
                   <i class = "fas fa-magnifying-glass pr-2" > </i> View Manuscript
                </a>`;
        }

        // editable => edit options
        let menuOptions = "";
        this.editController.sections.forEach(section => {
            menuOptions += `<a class="dropdown-item" onclick="page.${this.tableVarName}.openEditModal('${section.id}')">
                            <i class="${section.icon} dropdown-icon pr-2"></i> Edit ${section.title}
                        </a>`;
        });
        return menuOptions;
    }

    //Can edit by Id check
    private canEditById(id: any): boolean {
        const msId = Number(id);
        return !Number.isNaN(msId) && this.editableIdSet.has(msId);
    }

    openViewModal(manuscriptId: number): void {
        const $modal = $('#ms-detail-modal');
        $modal.find('.alert.alert-danger').remove();

        const ms = this.manuscripts.find(x => x.Id === manuscriptId);
        if (!ms) {
            $modal.find('.modal-body')
                .prepend('<div class="alert alert-danger">Manuscript not found.</div>');
            $modal.modal('show');
            return;
        }

        const vm = this.buildModalVm(ms);
        this.fillMsModal(vm);
        $modal.modal('show');
    }


    resizeTable(): void {
        if (this.manuscriptTable) {
            this.manuscriptTable.columns.adjust().draw();
        }
    }

    updateTable(items: any[]) {
        // Removes any shown menus
        $(`#${this.referenceId}-detail-menu-container`).empty();


        this.manuscriptTable.clear();
        this.manuscriptTable.rows.add(items).draw();
        this.updateCount(items.length);
        this.resizeTable();
        this.visibleManuscripts = items;
    }

    getCurrentTableSort(): any[] {
        let currentOrder: any[] = this.manuscriptTable.order(); // [[0, "asc"], [1, "desc"], ...]
        return currentOrder;
    }

    setCurrentTableSort(sortOrder: any[]): void {
        if (sortOrder.length > 0) {
            for (let i = 0; i < sortOrder.length; i++) {
                let colIndex = sortOrder[i][0];
                let colDir = sortOrder[i][1];
                this.manuscriptTable.order([colIndex, colDir]);
            }
            this.manuscriptTable.draw();
        }
    }

    scrollToManuscript(manuscriptId: number = -1) {
        if (manuscriptId == -1) {
            let idArr: number[] = this.manuscripts.map(am => am.Id);
            let maxVal = Math.max(...idArr);
            manuscriptId = maxVal;
        }

        let foundIndex = 0;

        // Find Row
        this.manuscriptTable.rows((index: number, data: Manuscript, node) => {
            if (data?.Id == manuscriptId) {
                foundIndex = index;
            }
            return false;
        });

        let foundRow = this.manuscriptTable.row(foundIndex);
        let foundRowHtml = foundRow.node();

        // Scroll to Row
        let foundRowPosition = $(foundRowHtml).position().top;
        let tableBody = $(`#${this.referenceId}-table-container`).find(".dataTables_scrollBody");
        tableBody.animate({ scrollTop: foundRowPosition }, 400);
    }

    openEditModal(sectionId: string): void {
        this.editController.showLoading(false);
        this.editController.initialize(this.allPickLists, [this.currentTargetItem], sectionId);
        $(`#${this.editController.modalIdTarget}`).modal('show');
    }

    openAddModal(): void {
        let newManuscript: Manuscript = new Manuscript();

        this.addController.showLoading(true);
        this.addController.initialize(this.allPickLists, newManuscript);
        $(`#${this.addController.modalIdTarget}`).modal('show');
    }

    saveEditModal() {
        this.editController.saveEditModal();
    }

    saveAddModal() {
        this.addController.saveAddModal();
    }

    private wireRowActions(): void {
        const tableSelector = `#${this.referenceId}-select-table`;

        $(document)
            .off('click', `${tableSelector} a.ms-title-link`)
            .on('click', `${tableSelector} a.ms-title-link`, (e) => {
                e.preventDefault();

                const $modal = $('#ms-detail-modal');
                $modal.find('.alert.alert-danger').remove();

                const id = Number($(e.currentTarget).attr('data-msid') || '0');
                const ms = this.manuscripts.find(x => x.Id === id);


                if (!ms) {
                    $modal.find('.modal-body')
                        .prepend('<div class="alert alert-danger">Manuscript not found.</div>');
                    $modal.modal('show');
                    return;
                }

                const vm = this.buildModalVm(ms);
                this.fillMsModal(vm);
                $modal.modal('show');
            });
    }


    private buildModalVm(m: Manuscript) {
        // status is sorted picklist (pl-ms-status)
        const statusText =
            this.renderPickListItem(m.StatusId, "pl-ms-status", false, true) || "";

        const centerText =
            this.renderPickListItem(m.CenterId, "pl-center") || "";

        const coreProjectHtml =
            this.renderCoreProject(m) || "";

        // CollaboratingCenterIds is a pipe string; we can convert to names via renderPickListItem
        const collabNamesStr =
            this.renderPickListItem(m.CollaboratingCenterIds, "pl-center", true) || "";
        const collabArr = collabNamesStr
            ? collabNamesStr.split(",").map(s => s.trim()).filter(Boolean)
            : [];

        const primary =
            this.renderPickListItem(m.PrimaryAuthorId, "pl-user") || "";
        const senior =
            this.renderPickListItem(m.SeniorAuthorId, "pl-user") || "";
        const networkIds = (m.NetworkAuthorIds || '')
            .split('|')
            .map(s => s.trim())
            .filter(Boolean);

        const networkArr = networkIds
            .map(id => this.renderPickListItem(id, "pl-user") || "")
            .map(s => s.trim())
            .filter(Boolean);


        return {
            Title: m.Title || "",
            LastUpdated: m.LastUpdated || null,

            Center: centerText,
            CoreProjectHtml: coreProjectHtml,

            Status: statusText,
            CollaboratingCenters: collabArr,

            Publications: {
                TargetJournal: (m.TargetJournal || "").trim(),
                PubMedId: (m.PubMedId || "").trim(),
                AnticipatedDate: m.AnticipatedDate || null,
            },

            Authors: {
                PrimaryAuthor: primary,
                SeniorAuthor: senior,
                NetworkAuthors: networkArr
            },

            Notes: (m.Notes || "").trim()
        };
    }
    private fillMsModal(vm: any): void {
        const $modal = $('#ms-detail-modal');
        const EmptyDisplay = this.EmptyDisplay;

        // -----------------------------
        // Pub-standard helpers
        // -----------------------------
        const setFieldText = (ddSelector: string, value?: string | null) => {
            const $dd = $modal.find(ddSelector);
            const $dt = $dd.prevAll('dt').first();
            const v = (value ?? '').trim();

            if (v) {
                $dt.removeClass('d-none');
                $dd.removeClass('d-none').text(v);
            } else {
                $dt.addClass('d-none');
                $dd.addClass('d-none').empty();
            }
        };


        const setAuthorCellHtml = (cellSelector: string, html?: string | null) => {
            const $cell = $modal.find(cellSelector);
            const has = !!html && html.trim().length > 0;
            if (has) $cell.removeClass('d-none').html(html!);
            else $cell.removeClass('d-none').empty();
        };

        // extract name + email from mixed strings 
        const extractNameAndEmail = (raw?: string | null): { name: string; email?: string } => {
            const value = (raw ?? '').trim();
            if (!value) return { name: '' };

            const emailMatch = value.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i);
            if (!emailMatch) return { name: value };

            const email = emailMatch[0];
            const name = value
                .replace(email, '')
                .replace(/[()<>;,]/g, ' ')
                .replace(/\s+/g, ' ')
                .trim() || email;

            return { name, email };
        };

        const renderNameWithMailIcon = (raw?: string | null): string => {
            const { name, email } = extractNameAndEmail(raw);
            if (!name && !email) return '';

            const safeName = _.escape(name || email || '');
            if (!email) return safeName;

            const safeEmail = _.escape(email);

            return `
            <a href="mailto:${safeEmail}"
               class="ms-mail-link mr-1 text-decoration-none"
               title="Email ${safeName}">
                <i class="fa-regular fa-envelope"></i>
            </a>${safeName}
        `;
        };

        // -----------------------------
        // Header
        // -----------------------------
        $modal.find('[data-ms="Title"]').text(vm.Title || EmptyDisplay);

        // Last updated (header line)
        const last = vm.LastUpdated ? getDisplayDate(vm.LastUpdated) : '';
        const $lastWrap = $modal.find('#ms-last-updated');
        const $lastText = $modal.find('[data-ms="LastUpdated"]');

        if (last) {
            $lastWrap.removeClass('d-none');
            $lastText.text(`${last}`);
        } else {
            $lastWrap.addClass('d-none');
            $lastText.text('');
        }

        // Anticipated Date
        const anticipateddate = vm.Publications?.AnticipatedDate ? getDisplayDate(vm.Publications.AnticipatedDate) : '';
        const $anticipatedDateWrap = $modal.find('#ms-anticipated-date');
        const $anticipatedDateText = $modal.find('[data-ms="AnticipatedDate"]');

        if (anticipateddate) {
            $anticipatedDateWrap.removeClass('d-none');
            $anticipatedDateText.text(`${anticipateddate}`);
        } else {
            $anticipatedDateWrap.addClass('d-none');
            $anticipatedDateText.text('');
        }

        // -----------------------------
        // Overview block
        // -----------------------------
        // Center 
        const center = (vm.Center ?? '').trim();
        $modal.find('[data-ms="Center"]').text(center);

        // Core/Project 
        const coreHtml = (vm.CoreProjectHtml ?? '').trim();
     
        $modal.find('[data-ms="CoreProject"]').html(coreHtml);

        // Status pill
        const status = (vm.Status ?? '').trim();
        const $statusHost = $modal.find('[data-ms="Status"]');
        if (status) {
            $statusHost.removeClass('d-none');
            this.renderPills($statusHost, [status]);
        } else {
            $statusHost.addClass('d-none').empty();
        }

        // Collaborating centers pills
        const collabs = (vm.CollaboratingCenters ?? [])
            .map((x: string) => (x ?? '').trim())
            .filter(Boolean);

        const $collabDd = $modal.find('[data-ms="CollaboratingCenters"]');
        const $collabDt = $collabDd.prevAll('dt').first();

        if (collabs.length) {
            $collabDt.removeClass('d-none');
            $collabDd.removeClass('d-none');
            this.renderPills($collabDd, collabs);
        } else {
            $collabDt.addClass('d-none');
            $collabDd.addClass('d-none').empty();
        }

        // Target Journal
        setFieldText('[data-ms="Publications.TargetJournal"]', vm.Publications?.TargetJournal);

        // -----------------------------
        // Authors (table cells)
        // -----------------------------
        const primaryHtml = renderNameWithMailIcon(vm.Authors?.PrimaryAuthor);
        const seniorHtml = renderNameWithMailIcon(vm.Authors?.SeniorAuthor);

        setAuthorCellHtml('[data-ms="Authors.Primary"]', primaryHtml);
        setAuthorCellHtml('[data-ms="Authors.Senior"]', seniorHtml);

        // Network authors (multiple possible)
        const netAuthorsHtml = (vm.Authors?.NetworkAuthors || [])
            .map((a: string) => (a ?? '').trim())
            .filter(Boolean)
            .map((a: string) => `<span class="ms-author-unit">${renderNameWithMailIcon(a)}</span>`)
            .join('<br>');

        setAuthorCellHtml('[data-ms="Authors.Network"]', netAuthorsHtml);

        // -----------------------------
        // Notes
        // -----------------------------
        setFieldText('[data-ms="Notes"]', vm.Notes);

        // -----------------------------
        // Footer: PubMed button
        // -----------------------------
        const pmid = (vm.Publications?.PubMedId ?? '').trim();
        const $pubmed = $modal.find('#ms-pubmed-link');

        if (pmid) {
            $pubmed
                .attr('href', `https://pubmed.ncbi.nlm.nih.gov/${encodeURIComponent(pmid)}/`)
                .removeClass('d-none');
        } else {
            $pubmed.attr('href', '#').addClass('d-none');
        }

        // -----------------------------
        // Section-level visibility
        // -----------------------------
        const hasOverview =
            !!center ||
            !!coreHtml ||
            !!status ||
            collabs.length > 0 ||
            !!(vm.Publications?.TargetJournal ?? '').trim();

        const hasAuthors =
            !!primaryHtml.trim() ||
            !!seniorHtml.trim() ||
            !!netAuthorsHtml.trim();

        const hasNotes = !!(vm.Notes ?? '').trim();

        $('#ms-overview-section').toggleClass('d-none', !hasOverview);

        $('#ms-authors-heading, #ms-authors-section, #ms-authors-row')
            .toggleClass('d-none', !hasAuthors);

        $('#ms-notes-section').toggleClass('d-none', !hasNotes);

        $('#ms-overview-divider').toggleClass('d-none', !(hasOverview && (hasAuthors || hasNotes)));
        $('#ms-authors-divider').toggleClass('d-none', !(hasAuthors && hasNotes));
    }


   
    // ---PILLS Helper for Modal ---
    private renderPills($host: JQuery, items: string[]) {
        const EmptyDisplay = '-none-';
        const pillClass = ($host.attr('data-pill-class') || 'pill').trim();
        $host.empty();

        const clean = (items || []).filter(x => x && x.trim().length);
        if (!clean.length) {
            $host.text(EmptyDisplay);
            return;
        }

        clean.forEach(txt => {
            const $pill = $('<span/>', { class: pillClass }).append(
                $('<span/>', { text: txt })
            );
            $host.append($pill);
        });
    }

}